import React, { useState, useEffect } from 'react';
import axios from "axios";
import { FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import firebase from '../util/firebase';


class Registrieren extends React.Component {
    constructor() {
        super()
        this.state = {
            firstName: "",
            lastName: "",
            age: "",
            destination: "",
            agreement: "",
        }
        this.handleChange = this.handleChange.bind(this)
    }
    
    componentDidUpdate() {
    }

    onSubmit = (e) => {
        e.preventDefault();


        const todoRef = firebase.database().ref("contacts")
        const firstName = this.state.firstName
        const lastName = this.state.lastName
        const age = this.state.age
        const agreement = this.state.agreement ? "Yes" : "No"
        const destination = this.state.destination
        const todo = {
            firstName,
            lastName,
            age,
            destination,
            agreement,
            complete: false,
        };
        todoRef.push(todo);
        // axios
        //     .post('https://unterzeichner-3cdb0-default-rtdb.europe-west1.firebasedatabase.app/contacts', this.state)
        //     .then(response => {
        //         console.log(response)
        //         let item = document.createElement("DIV");
        //         let t = document.createTextNode(response.data.firstName + " " + response.data.lastName + " (" + response.data.age + ")");
        //         item.appendChild(t);
        //         const element = document.getElementById("myDIV");
        //         element.appendChild(item);
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
        alert("Vielen Dank! " + this.state.firstName + ' ' + this.state.lastName + ". Sie werden gleich in die Unterzeichnernliste eingetragen.");
        let x = document.getElementById("btn")
        let y = document.getElementById("btn1")
            x.style.display = "none";
            y.style.display = "inline-block";
        
      };

    handleChange = (e) => {
        const {name, value} = e.target
        this.setState({
            [name]: value
        });
    };

render() {
    return (
        <main className="flex">
            <div className="frm">
                <div class="head"></div>
                <form onSubmit={this.onSubmit}>
                    <h1 className="header1">Seien Sie dabei</h1>
                    <p className="margin">Bitte die Felder zum Unterschreiben ausfüllen.</p>
                    <hr/>
                    <input 
                        name="firstName" 
                        title="tippen Sie bitte Ihren Vornamen"
                        type="text"
                        value={this.state.firstName}
                        placeholder="Vorname"  
                        onChange={this.handleChange}
                        required
                    />
                    <br />
                    <input 
                        name="lastName" 
                        title="tippen Sie bitte Ihren Nachnamen"
                        type="text"
                        value={this.state.lastName}
                        placeholder="Nachname" 
                        onChange={this.handleChange}
                        required
                    />
                    <br />
                    <input 
                        name="age" 
                        title="tippen Sie bitte Ihren Alter"
                        type="number"
                        value={this.state.age}
                        placeholder="Alter" 
                        onChange={this.handleChange}
                    />
                    
                    <br />
                    <select 
                        value={this.state.destination} 
                        name="destination" 
                        onChange={this.handleChange}
                    >
                        <option>-- Wählen Sie bitte Ihr Bundesland --</option>
                        <option>Baden-Württemberg</option>
                        <option>Bayern</option>
                        <option>Berlin</option>
                        <option>Brandenburg</option>
                        <option>Bremen</option>
                        <option>Hamburg</option>
                        <option>Hessen</option>
                        <option>Mecklenburg-Vorpommern</option>
                        <option>Niedersachsen</option>
                        <option >Nordrhein-Westfalen</option>
                        <option>Rheinland-Pfalz</option>
                        <option>Saarland</option>
                        <option>Sachsen</option>
                        <option>Sachsen-Anhalt</option>
                        <option>Schleswig-Holstein</option>
                        <option>Thüringen</option>
                    </select>
                    <br />
                    {/* <label className="agreement"> 
                        <input 
                            name="agreement"
                            type="checkbox"
                            value={this.state.agreement}
                            placeholder="" 
                            onChange={this.handleChange}
                        />
                        Ich bin mit der Veröffenlichung dieser Daten einverstanden
                    </label> */}
                    <FormControlLabel className="agreement"
                        control={
                            <Checkbox 
                                name="agreement"
                                color="Primary" 
                                onChange={this.handleChange}
                                value={this.state.agreement}
                                required
                                />
                                }
                        label={<div className="checkText">Ich bin mit der Veröffentlichung dieser Daten einverstanden</div>}
                    />
                    <br />
                    <button id="btn" type="submit">Absenden</button>
                </form>
                <button className="hidden" id="btn1">Vielen Dank! {this.state.firstName} {this.state.lastName} für Ihre Unterstützung</button>
                <div class="Footer"></div>
            </div>
        </main>   
    );
}
}

export default Registrieren;